/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Weather_Snow_GrainsInputs */

const en_ui_weather_snow_grains = /** @type {(inputs: Ui_Weather_Snow_GrainsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snow grains`)
};

const de_ui_weather_snow_grains = /** @type {(inputs: Ui_Weather_Snow_GrainsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schneegriesel`)
};

/**
* | output |
* | --- |
* | "Snow grains" |
*
* @param {Ui_Weather_Snow_GrainsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_weather_snow_grains = /** @type {((inputs?: Ui_Weather_Snow_GrainsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Weather_Snow_GrainsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_weather_snow_grains(inputs)
	return de_ui_weather_snow_grains(inputs)
});